import { render, staticRenderFns } from "./H5.vue?vue&type=template&id=3b43e283&scoped=true"
import script from "./H5.vue?vue&type=script&lang=js"
export * from "./H5.vue?vue&type=script&lang=js"
import style0 from "./H5.vue?vue&type=style&index=0&id=3b43e283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43e283",
  null
  
)

export default component.exports